import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import { useOidcContext } from '../contexts/OidcContext';
import { useTranslation } from '../i18n/useTranslation';

interface Props {
  status: 'pending' | 'rejected' | string;
  organizationName: string;
}

export default function MemberPendingPage({ status, organizationName }: Props) {
  const { logout } = useOidcContext();
  const t = useTranslation();

  const isRejected = status === 'rejected';
  const titleKey = isRejected ? 'memberPending.title.rejected' : 'memberPending.title.pending';
  const bodyKey = isRejected ? 'memberPending.body.rejected' : 'memberPending.body.pending';
  const accent = isRejected ? '#C24242' : '#2C4A69';
  const accentBg = isRejected ? '#fef2f2' : '#f0f4f8';
  const Icon = isRejected ? BlockRoundedIcon : HourglassEmptyRoundedIcon;

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f8f8fa"
      p={3}
    >
      <Card
        sx={{
          maxWidth: 480,
          width: '100%',
          p: 5,
          border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: '12px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '16px',
            bgcolor: accentBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
          }}
        >
          <Icon sx={{ fontSize: 30, color: accent }} />
        </Box>
        <Typography
          variant="h5"
          sx={{ fontWeight: 700, mb: 1.5, letterSpacing: '-0.02em', color: 'text.primary' }}
        >
          {t(titleKey)}
        </Typography>
        <Typography sx={{ color: 'text.secondary', lineHeight: 1.7, fontSize: '0.95rem' }}>
          {t(bodyKey).replace('{org}', organizationName)}
        </Typography>
        <Button
          onClick={() =>
            logout({ logoutParams: { returnTo: window.location.origin + '/login' } })
          }
          sx={{
            'mt': 4,
            'color': 'text.disabled',
            'textTransform': 'none',
            'fontSize': '0.85rem',
            'fontWeight': 400,
            '&:hover': { color: 'text.secondary', bgcolor: 'transparent' },
          }}
        >
          {t('memberPending.logout')}
        </Button>
      </Card>
    </Box>
  );
}
